document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.ImageSlider__thumbnail')
  const dialogs: NodeListOf<HTMLDialogElement> = document.querySelectorAll(
    '.ImageSlider__dialog',
  )

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', function () {
      // Close any open dialogs first
      dialogs.forEach((dialog) => {
        if (dialog.open) {
          dialog.close()
        }
      })

      // Show the corresponding dialog
      const dialog = dialogs[index]
      if (dialog) {
        dialog.showModal()
      }
    })
  })

  // Close dialog when clicking outside of it or on close button
  dialogs.forEach((dialog) => {
    // Close when clicking on close button
    const closeBtn = dialog.querySelector('.close-btn')
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close()
      })
    }

    // Close when pressing Escape key (this is automatic with showModal)
    // But we still handle it for consistency
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        dialog.close()
      }
    })
  })
})
